// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__1NmmU","description":"home_description__2vR7W","subtitle":"home_subtitle__2HQFU"};